module.exports = {"441223100":"排沙镇","441223102":"潭布镇","441223103":"江屯镇","441223105":"螺岗镇","441223106":"北市镇","441223107":"坑口镇","441223108":"赤坑镇","441223109":"南街镇","441223110":"宾亨镇","441223111":"五和镇","441223112":"横山镇","441223113":"木格镇","441223114":"石咀镇","441223115":"古水镇","441223116":"洲仔镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441223.json
// module id = 2014
// module chunks = 0